import React, { useState } from 'react';
import classNames from 'classnames';
import Pic from '../../../assets/img/wanna/richie/richie.png';
import Pic2 from '../../../assets/img/wanna/richie/richie2.png';
import Pic3 from '../../../assets/img/wanna/richie/richie3.png';
import Pic4 from '../../../assets/img/wanna/richie/richie4.png';
import Pic5 from '../../../assets/img/wanna/richie/richie5.png';
import Pic6 from '../../../assets/img/wanna/richie/richie6.png';
import Pic7 from '../../../assets/img/wanna/richie/richie7.png';
import Pic8 from '../../../assets/img/wanna/richie/richie8.png';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';

const ContentLibrary = ({ darkModeStatus, imageClass }) => {
	const images = [
		{ id: 'Pic', img: Pic },
		{ id: 'Pic2', img: Pic2 },
		{ id: 'Pic3', img: Pic3 },
		{ id: 'Pic4', img: Pic4 },
		{ id: 'Pic5', img: Pic5 },
		{ id: 'Pic6', img: Pic6 },
		{ id: 'Pic7', img: Pic7 },
		{ id: 'Pic8', img: Pic8 },
		{ id: 'Pic9', img: Pic8 },
		{ id: 'Pic10', img: Pic8 },
	];
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'dark'];
	const [selectedImage, setSelectedImage] = useState(null);

	return (
		<>
			<div className='row g-4'>
				{images.map((item, index) => (
					<div key={item.id} className={imageClass}>
						<button
							type='button'
							onClick={() => setSelectedImage(item.img)}
							className={classNames(
								'ratio ratio-1x1',
								'rounded-2',
								'border-0',
								`bg-l${darkModeStatus ? 'o25' : '25'}-${colors[index % 7]}`,
								`bg-l${darkModeStatus ? 'o50' : '10'}-${colors[index % 7]}-hover`,
							)}>
							<img
								src={item.img}
								alt={item.id}
								width='100%'
								height='auto'
								className='object-fit-contain p-4'
							/>
						</button>
					</div>
				))}
			</div>
			<Modal setIsOpen={setSelectedImage} isOpen={!!selectedImage} isCentered>
				<ModalHeader setIsOpen={setSelectedImage}>
					<ModalTitle id='preview'>Preview</ModalTitle>
				</ModalHeader>
				<ModalBody>
					<img src={selectedImage} alt='eneme' />
				</ModalBody>
			</Modal>
		</>
	);
};
export default ContentLibrary;
